export * from './lib/text-editor.component';
